import Button from "components/atoms/Button";
import InputCheckbox from "components/atoms/InputCheckbox";
import InputDate from "components/atoms/InputDate";
import InputField from "components/atoms/InputField";
import InputRadio from "components/atoms/InputRadio";
import InputSelect from "components/atoms/InputSelect";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getCurrentUserFromLocalStorage } from "utils/common";
import {
  AgeTypeOptions,
  GenderOptions,
  PageMode,
  PregnancyStatusOptions,
  YesAndNoOptions,
  OAPOptions,
} from "utils/constant";

const PersonalDataStepForm = ({
  onNextStep,
  changeMode,
  formik,
  addressData,
  domicileData,
  handleAddressChange,
  countries,
  pageMode,
  isPe,
  isNotifikasiBKK,
  referenceData,
}) => {
  const [isBKK, setisBKK] = useState(false);
  // Derived dari formik.values — tahan terhadap unmount/remount saat navigasi antar step
  const ageTypeDisable =
    formik.values.not_have_ktp === "Ya" && !!formik.values.dob;
  const [isEdit, setisEdit] = useState(
    pageMode === PageMode.edit && isNotifikasiBKK,
  );
  const { currentUser } = useSelector((state) => state.authReducer);
  const isBKKUser =
    currentUser.level === "BKKWilker" || currentUser.level === "BKKInduk";

  useEffect(() => {
    window.scrollTo(0, 0);
    const user = getCurrentUserFromLocalStorage();
    const checkList = ["KKP", "BKK", "LKK", "WILKER"];
    checkList.forEach((e) => {
      if (user.first_name.includes(e)) setisBKK(true);
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {isBKKUser && (
        <>
          <InputSelect
            label={"Provinsi Tujuan"}
            name={"ref_bkk_province_id"}
            placeholder={"Pilih Provinsi"}
            data={referenceData.provincies}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue) {
                formik.handleChange("ref_bkk_province_id")(selectedValue);
              }
            }}
            onBlur={formik.handleBlur}
            value={referenceData.provincies?.find(
              (item) => item.value === formik.values.ref_bkk_province_id,
            )}
            error={
              formik.errors.ref_bkk_province_id &&
              formik.touched.ref_bkk_province_id
            }
            errorMessage={formik.errors.ref_bkk_province_id}
            isRequired={true}
            disabled={isBKKUser && isEdit}
          />
          <InputSelect
            label={"BKK Tujuan"}
            name={"ref_bkk_id"}
            placeholder={"Pilih BKK Tujuan"}
            data={referenceData.bkk}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue) {
                formik.handleChange("ref_bkk_id")(selectedValue);
              }
            }}
            onBlur={formik.handleBlur}
            value={referenceData.bkk?.find(
              (item) => item.value === formik.values.ref_bkk_id,
            )}
            error={formik.errors.ref_bkk_id && formik.touched.ref_bkk_id}
            errorMessage={formik.errors.ref_bkk_id}
            isRequired={true}
            isDisabled={
              !formik.values.ref_bkk_province_id || (isBKKUser && isEdit)
            }
          />
          <InputSelect
            label={"Kabupaten/Kota Tujuan"}
            name={"ref_bkk_district_id"}
            placeholder={"Pilih Kabupaten/Kota Tujuan"}
            data={referenceData.bkkDistricts}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue) {
                formik.handleChange("ref_bkk_district_id")(selectedValue);
              }
            }}
            onBlur={formik.handleBlur}
            value={referenceData.bkkDistricts?.find(
              (item) => item.value === formik.values.ref_bkk_district_id,
            )}
            error={
              formik.errors.ref_bkk_district_id &&
              formik.touched.ref_bkk_district_id
            }
            errorMessage={formik.errors.ref_bkk_district_id}
            isRequired={true}
            isDisabled={!formik.values.ref_bkk_province_id}
          />
        </>
      )}
      {/* Centang jika warna negara asing */}
      <InputCheckbox
        options={[{ label: "Centang Jika Warga Negara Asing", value: "Ya" }]}
        name="is_foreign_nationality"
        onChange={(e) => {
          const selectedValue = e.target.checked ? "Ya" : "Tidak";

          if (selectedValue === "Ya") {
            formik.handleChange("ktp")("");
            formik.handleChange("not_have_ktp")("Tidak");
            formik.setFieldValue("dob", "");
          }

          formik.handleChange("is_foreign_nationality")(selectedValue);
        }}
        onBlur={formik.handleBlur}
        selectedOption={formik.values.is_foreign_nationality}
        disabled={isBKK && isEdit}
      />

      {formik.values.is_foreign_nationality === "Ya" && (
        <>
          <InputSelect
            label={"Negara"}
            name={"nationality"}
            placeholder={"Pilih Negara"}
            data={countries}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";

              if (selectedValue !== undefined) {
                formik.handleChange("nationality")(selectedValue);
              }
            }}
            onBlur={formik.handleBlur}
            value={countries?.find(
              (item) => item.value === formik.values.nationality,
            )}
            error={formik.errors.nationality && formik.touched.nationality}
            errorMessage={formik.errors.nationality}
            isRequired={true}
            disabled={isBKK && isEdit}
          />
          <InputField
            label={"No. Passpor/Pas Lintas Batas/Nomor Identitas"}
            name={"no_identitas"}
            placeholder={
              "Masukkan No. Passpor/Pas Lintas Batas/Nomor Identitas"
            }
            {...formik.getFieldProps("no_identitas")}
            error={
              formik.touched.no_identitas && Boolean(formik.errors.no_identitas)
            }
            errorMessage={formik.errors.no_identitas}
            isRequired={true}
            disabled={isBKK && isEdit}
          />
        </>
      )}

      {formik.values.is_foreign_nationality !== "Ya" && (
        <>
          {/*  */}
          {formik.values.not_have_ktp !== "Ya" && (
            <InputField
              label={"NIK"}
              name={"ktp"}
              placeholder={"Masukkan Nomor KTP/NIK"}
              maxLengthVal={16}
              type={"number"}
              {...formik.getFieldProps("ktp")}
              // errorMessage={formik?.errors?.ktp}
              error={formik.touched.ktp && Boolean(formik.errors.ktp)}
              errorMessage={formik.errors.ktp}
              isRequired={true}
              disabled={isBKK && isEdit}
            />
          )}
          <InputCheckbox
            options={[
              { label: "Centang Jika Tidak Memiliki KTP", value: "Ya" },
            ]}
            name="not_have_ktp"
            onChange={(e) => {
              const selectedValue = e.target.checked ? "Ya" : "Tidak";
              formik.handleChange("not_have_ktp")(selectedValue);
              if (selectedValue !== "Ya") {
                formik.setFieldValue("ktp", "");
                formik.setFieldValue("dob", "");
                formik.setFieldValue("age", "");
                formik.setFieldValue("age_type", "");
              }
            }}
            onBlur={formik.handleBlur}
            selectedOption={formik.values.not_have_ktp}
            disabled={isBKK && isEdit}
          />
        </>
      )}

      {formik.values.not_have_ktp === "Ya" && (
        <InputDate
          label={"Tanggal Lahir"}
          name={"dob"}
          placeholder={"Pilih Tanggal Lahir"}
          dateFormat={"DD-MM-YYYY"}
          value={
            formik.values.dob
              ? moment(formik.values.dob, ["DD-MM-YYYY", "YYYY-MM-DD"])
              : ""
          }
          onChange={(value) => {
            const selectedValue = value
              ? moment(value).format("DD-MM-YYYY")
              : "";
            formik.handleChange("dob")(selectedValue);

            if (selectedValue) {
              const birth = moment(selectedValue, "DD-MM-YYYY");
              const now = moment();
              if (birth.isValid()) {
                const years = now.diff(birth, "years");
                if (years >= 1) {
                  formik.setFieldValue("age", years);
                  formik.setFieldValue("age_type", "Tahun");
                } else {
                  const months = now.diff(birth, "months");
                  const ageValue = Math.max(months, 1);
                  formik.setFieldValue("age", ageValue);
                  formik.setFieldValue("age_type", "Bulan");
                }
              }
            }
          }}
          onBlur={formik.handleBlur}
          error={formik.errors.dob && formik.touched.dob}
          errorMessage={formik.errors.dob}
          isRequired={true}
          disabled={isBKK && isEdit}
        />
      )}

      <div className="row">
        <div className="col-sm-4">
          <InputField
            label={"Nama"}
            name={"name"}
            {...formik.getFieldProps("name")}
            placeholder={"Masukkan nama"}
            error={formik.errors.name && formik.touched.name}
            errorMessage={formik.errors.name}
            isRequired={true}
            disabled={isBKK && isEdit}
          />
        </div>
        <div className="col-sm-4">
          <InputField
            label={"Usia"}
            name={"age"}
            type={"number"}
            placeholder={"Masukkan Usia"}
            maxLengthVal={2}
            onChange={(e) => {
              const selectedValue = e.target.value;
              if (parseInt(selectedValue, 10) >= 12) {
                formik.setFieldValue("age_type", "Tahun");
              } else {
                formik.setFieldValue("age_type", "Bulan");
              }
              formik.handleChange("age")(selectedValue);
              const age = parseInt(selectedValue, 10);
              const ageType = age >= 12 ? "Tahun" : formik.values.age_type;
              if (ageType === "Bulan" || (ageType === "Tahun" && age < 10)) {
                formik.setFieldValue("pregnancy", "");
                formik.setFieldValue("breastfeeding", "");
              }
            }}
            onBlur={formik.handleBlur}
            value={formik.values.age}
            error={formik.errors.age && formik.touched.age}
            errorMessage={formik.errors.age}
            isRequired={true}
            disabled={ageTypeDisable || (isBKK && isEdit)}
          />
        </div>
        <div className="col-sm-4">
          <InputSelect
            label={"Tahun/Bulan"}
            name={"age_type"}
            placeholder={"Pilih Tahun/Bulan"}
            data={AgeTypeOptions}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";

              if (selectedValue !== undefined) {
                formik.handleChange("age_type")(selectedValue);
                if (
                  selectedValue === "Bulan" ||
                  (selectedValue === "Tahun" && formik.values.age < 10)
                ) {
                  formik.setFieldValue("pregnancy", "");
                  formik.setFieldValue("breastfeeding", "");
                }
              }
            }}
            onBlur={formik.handleBlur}
            value={AgeTypeOptions?.find(
              (item) => item.value === formik.values.age_type,
            )}
            error={formik.errors.age_type && formik.touched.age_type}
            errorMessage={formik.errors.age_type}
            isRequired={true}
            isDisabled={ageTypeDisable || formik.values.age >= 12}
          />
        </div>
      </div>

      <InputSelect
        label={"Jenis Kelamin"}
        name={"gender"}
        placeholder={"Pilih Jenis Kelamin"}
        data={GenderOptions}
        onChange={(e) => {
          const selectedValue = e ? e.value : "";
          if (selectedValue !== undefined) {
            formik.handleChange("gender")(selectedValue);
          }
          if (selectedValue !== "Perempuan") {
            formik.setFieldValue("breastfeeding", "");
            formik.setFieldValue("pregnancy", "");
            formik.setFieldValue("discovery_activities", "");
            formik.setFieldValue("house_visit", "");
            formik.setFieldValue("isCadre", "");
            formik.setFieldValue("cadres_id", "");
          }
        }}
        onBlur={formik.handleBlur}
        value={GenderOptions?.find(
          (item) => item.value === formik.values.gender,
        )}
        error={formik.errors.gender && formik.touched.gender}
        errorMessage={formik.errors.gender}
        isRequired={true}
        disabled={isBKK && isEdit}
      />

      <InputRadio
        label="Status Kependudukan (Khusus Papua)"
        name="oap"
        options={OAPOptions}
        onChange={(e) => {
          const selectedValue = e.target.value;
          formik.handleChange("oap")(selectedValue);
        }}
        onBlur={formik.handleBlur}
        selectedOption={formik.values.oap}
        error={formik.errors.oap && formik.touched.oap}
        errorMessage={formik.errors.oap}
        isRequired={true}
        disabled={isBKK && isEdit}
      />

      {((formik.values.gender === "Perempuan" &&
        formik.values.age >= 10 &&
        formik.values.age_type === "Tahun") ||
        formik.values.breastfeeding === "Ya") && (
        <InputSelect
          label={"Status Maternitas"}
          name={"pregnancy"}
          placeholder={"Pilih Status Maternitas"}
          data={PregnancyStatusOptions}
          onChange={(e) => {
            const selectedValue = e ? e.value : "";

            if (selectedValue !== undefined) {
              if (selectedValue === "Tidak Hamil") {
                formik.setFieldValue("discovery_activities", "");
                formik.setFieldValue("house_visit", "");
                formik.setFieldValue("isCadre", "");
                formik.setFieldValue("cadres_id", "");
              }
              if (selectedValue !== "Menyusui Bayi < 1 Bulan") {
                formik.handleChange("pregnancy")(selectedValue);
                formik.handleChange("breastfeeding")("");
              }

              if (selectedValue === "Menyusui Bayi < 1 Bulan") {
                formik.handleChange("breastfeeding")("Ya");
                formik.handleChange("pregnancy")("");
              }
            }
          }}
          onBlur={formik.handleBlur}
          value={PregnancyStatusOptions?.find(
            (item) =>
              item.value ===
              (formik.values.breastfeeding === "Ya"
                ? "Menyusui Bayi < 1 Bulan"
                : formik.values.pregnancy),
          )}
          error={formik.errors.pregnancy && formik.touched.pregnancy}
          errorMessage={formik.errors.pregnancy}
          isRequired={true}
          disabled={isBKK && isEdit}
        />
      )}

      <hr />

      <h3 className="subtitle-section">
        Alamat Domisili
      </h3>

      <div className="row">
        <div className="col-sm-6">
          <InputSelect
            label={"Provinsi"}
            name={"province_id"}
            placeholder={"Pilih Provinsi"}
            data={addressData.provincies}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue !== undefined) {
                formik.handleChange("province_id")(selectedValue);
              }
            }}
            onBlur={formik.handleBlur}
            value={addressData.provincies?.find(
              (item) => item.value === formik.values.province_id,
            )}
            error={formik.errors.province_id && formik.touched.province_id}
            errorMessage={formik.errors.province_id}
            isRequired={true}
            isDisabled={
              !isBKK ||
              (pageMode === PageMode.edit && isPe) ||
              (isBKK && isEdit)
            }
          />
        </div>
        <div className="col-sm-6">
          <InputSelect
            label={"Kabupaten/Kota"}
            name={"district_id"}
            placeholder={"Pilih Kabupaten"}
            data={addressData.districts}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue) {
                formik.handleChange("district_id")(selectedValue);
                formik.setFieldValue("subdistrict_id", "");
                formik.setFieldValue("fasyankes_id", "");
                formik.setFieldValue("urbanvillage_id", "");
              }
            }}
            onBlur={formik.handleBlur}
            value={
              addressData.districts?.find(
                (item) => item.value === formik.values.district_id,
              ) || ""
            }
            error={formik.errors.district_id && formik.touched.district_id}
            errorMessage={formik.errors.district_id}
            isRequired={true}
            isDisabled={
              !formik.values.province_id ||
              (pageMode === PageMode.edit && isPe) ||
              (isBKK && isEdit)
            }
          />
        </div>
      </div>

      <div className="row">
        {/* {formik.values.district_id && ( */}
        <div className="col-sm-6">
          <InputSelect
            label={"Kecamatan"}
            name={"subdistrict_id"}
            placeholder={"Pilih Kecamatan"}
            data={addressData.subdistricts}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue) {
                formik.handleChange("subdistrict_id")(selectedValue);
                formik.setFieldValue("fasyankes_id", "");
                formik.setFieldValue("urbanvillage_id", "");
              }
            }}
            onBlur={formik.handleBlur}
            value={
              addressData.subdistricts?.find(
                (item) => item.value === formik.values.subdistrict_id,
              ) || ""
            }
            error={
              formik.errors.subdistrict_id && formik.touched.subdistrict_id
            }
            errorMessage={formik.errors.subdistrict_id}
            isRequired={true}
            isDisabled={
              !formik.values.district_id || (pageMode === PageMode.edit && isPe)
            }
          />
        </div>
        {/* )} */}
        {/* {formik.values.subdistrict_id && ( */}
        <div className="col-sm-6">
          <InputSelect
            label={"Nama Fasyankes"}
            name={"fasyankes_id"}
            placeholder={"Pilih Fasyankes"}
            data={addressData.fasyankes}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue) {
                formik.handleChange("fasyankes_id")(selectedValue);
                formik.setFieldValue("urbanvillage_id", "");
              }
            }}
            onBlur={formik.handleBlur}
            value={
              addressData.fasyankes?.find(
                (item) => item.value === formik.values.fasyankes_id,
              ) || ""
            }
            error={formik.errors.fasyankes_id && formik.touched.fasyankes_id}
            errorMessage={formik.errors.fasyankes_id}
            isRequired={true}
            isDisabled={
              !formik.values.subdistrict_id ||
              (pageMode === PageMode.edit && isPe)
            }
          />
        </div>
        {/* )} */}
      </div>

      <div className="row">
        <div className="col-sm-6">
          <InputSelect
            label={"Nama Desa"}
            name={"urbanvillage_id"}
            placeholder={"Pilih Desa"}
            data={addressData.urbanvillages}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue) {
                formik.handleChange("urbanvillage_id")(selectedValue);
              }
            }}
            onBlur={formik.handleBlur}
            value={
              addressData.urbanvillages?.find(
                (item) => item.value === formik.values.urbanvillage_id,
              ) || ""
            }
            error={
              formik.errors.urbanvillage_id && formik.touched.urbanvillage_id
            }
            errorMessage={formik.errors.urbanvillage_id}
            isRequired={true}
            isDisabled={
              !formik.values.fasyankes_id ||
              (pageMode === PageMode.edit && isPe)
            }
          />
        </div>
        <div className="col-sm-6">
          <InputField
            label={"Nama Dusun"}
            name={"sub_village"}
            placeholder={"Masukkan Nama Dusun"}
            {...formik.getFieldProps("sub_village")}
            error={formik.errors.sub_village && formik.touched.sub_village}
            errorMessage={formik.errors.sub_village}
            isRequired={true}
          />
        </div>
      </div>

      <InputField
        label={"Alamat Lengkap"}
        name={"address"}
        placeholder={"Masukkan Alamat Lengkap"}
        type={"textarea"}
        {...formik.getFieldProps("address")}
        error={formik.errors.address && formik.touched.address}
        errorMessage={formik.errors.address}
        isRequired={true}
      />

      <InputField
        type={"number"}
        label={"No HP Pasien"}
        placeholder={"Masukkan no hp pasien"}
        {...formik.getFieldProps("no_hp")}
        error={formik.errors.no_hp && formik.touched.no_hp}
        errorMessage={formik.errors.no_hp}
        isRequired={true}
        maxLengthVal={15}
      />

      <InputRadio
        label="Apakah Pasien Beralamat (KTP) Diluar Wilayah ?"
        name="is_domicile_outside"
        options={YesAndNoOptions}
        onChange={(e) => {
          const selectedValue = e.target.value;

          if (selectedValue === "Tidak") {
            formik.setFieldValue("domicile_province_id", "");
            formik.setFieldValue("domicile_district_id", "");
            formik.setFieldValue("domicile_subdistrict_id", "");
            formik.setFieldValue("domicile_fasyankes_id", "");
          }

          formik.handleChange("is_domicile_outside")(selectedValue);
        }}
        onBlur={formik.handleBlur}
        selectedOption={formik.values.is_domicile_outside}
        error={
          formik.errors.is_domicile_outside &&
          formik.touched.is_domicile_outside
        }
        errorMessage={formik.errors.is_domicile_outside}
        isRequired={true}
        disabled={isBKK && isEdit}
      />

      {formik.values.is_domicile_outside === "Ya" && (
        <>
          <InputSelect
            label={"Provinsi"}
            name={"domicile_province_id"}
            placeholder={"Pilih Provinsi"}
            data={domicileData.provincies}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue) {
                formik.handleChange("domicile_province_id")(selectedValue);
                formik.setFieldValue("domicile_district_id", "");
                formik.setFieldValue("domicile_subdistrict_id", "");
                formik.setFieldValue("domicile_fasyankes_id", "");
              }
            }}
            onBlur={formik.handleBlur}
            value={
              domicileData.provincies?.find(
                (item) => item.value === formik.values.domicile_province_id,
              ) || ""
            }
            error={
              formik.errors.domicile_province_id &&
              formik.touched.domicile_province_id
            }
            errorMessage={formik.errors.domicile_province_id}
            isRequired={true}
          />
          <InputSelect
            label={"Kabupaten/Kota"}
            name={"domicile_district_id"}
            placeholder={"Pilih Kabupaten/Kota"}
            data={domicileData.districts}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue) {
                formik.handleChange("domicile_district_id")(selectedValue);
                formik.setFieldValue("domicile_subdistrict_id", "");
                formik.setFieldValue("domicile_fasyankes_id", "");
              }
            }}
            onBlur={formik.handleBlur}
            value={
              domicileData.districts?.find(
                (item) => item.value === formik.values.domicile_district_id,
              ) || ""
            }
            error={
              formik.errors.domicile_district_id &&
              formik.touched.domicile_district_id
            }
            errorMessage={formik.errors.domicile_district_id}
            isRequired={true}
            isDisabled={!formik.values.domicile_province_id}
          />
          <InputSelect
            label={"Kecamatan"}
            name={"domicile_subdistrict_id"}
            placeholder={"Pilih Kecamatan"}
            data={domicileData.subdistricts}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue) {
                formik.handleChange("domicile_subdistrict_id")(selectedValue);
                formik.setFieldValue("domicile_fasyankes_id", "");
              }
            }}
            onBlur={formik.handleBlur}
            value={
              domicileData.subdistricts?.find(
                (item) => item.value === formik.values.domicile_subdistrict_id,
              ) || ""
            }
            isDisabled={!formik.values.domicile_district_id}
          />
          <InputSelect
            label={"Fasyankes"}
            name={"domicile_fasyankes_id"}
            placeholder={"Pilih Fasyankes"}
            data={domicileData.fasyankes}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue) {
                formik.handleChange("domicile_fasyankes_id")(selectedValue);
              }
            }}
            onBlur={formik.handleBlur}
            value={
              domicileData.fasyankes?.find(
                (item) => item.value === formik.values.domicile_fasyankes_id,
              ) || ""
            }
            isDisabled={!formik.values.domicile_subdistrict_id}
          />
        </>
      )}

      <hr />
      <div className="form_action">
        <Button
          variant={"tertiary"}
          size={"normal"}
          onClick={() => changeMode(PageMode.view)}
        >
          Batalkan
        </Button>
        <Button
          variant={"primary"}
          size={"normal"}
          onClick={onNextStep}
          isDisabled={
            (formik.values.is_foreign_nationality === "Ya" &&
              !formik.values.nationality &&
              !formik.values.no_identitas) ||
            (formik.values.ktp !== "" && formik.errors.ktp) ||
            (formik.values.not_have_ktp === "Tidak" &&
              !formik.values.ktp &&
              !(
                formik.values.is_foreign_nationality === "Ya" &&
                formik.values.no_identitas
              )) ||
            !formik.values.name ||
            !formik.values.age ||
            !formik.values.age_type ||
            !formik.values.gender ||
            !formik.values.oap ||
            !formik.values.province_id ||
            !formik.values.district_id ||
            !formik.values.subdistrict_id ||
            !formik.values.urbanvillage_id ||
            !formik.values.sub_village ||
            !formik.values.address ||
            !formik.values.is_domicile_outside ||
            (formik.values.is_domicile_outside === "Ya" &&
              !formik.values.domicile_province_id) ||
            (formik.values.is_domicile_outside === "Ya" &&
              !formik.values.domicile_district_id)
          }
        >
          Selanjutnya
        </Button>
      </div>
      <hr />
    </>
  );
};

export default PersonalDataStepForm;
